import client from './client';

export default {
  create(user, cb) {
    client.request('post', '/users')
      .send({ user })
      .end(cb);
  },
  update(user, cb) {
    client.request('put', `/users/${user.id}`, true)
      .send({ user })
      .end(cb);
  },
  all(cb) {
    client.request('get', '/users', true)
      .end(cb);
  },
  create_log(params, cb) {
    client.request('post', '/logs', true)
      .send(params)
      .end(cb);
  },
  create_sso(user, cb) {
    client.request('post', '/sso_users', true)
      .send({ user })
      .end(cb);
  },
  create_club_membership(params, cb) {
    client.request('post', '/club_memberships', true)
      .send(params)
      .end(cb);
  },
};



// WEBPACK FOOTER //
// ./src/lib/user.js